import store from '@/store/index'
import apiConfig from '@/api/api'

const { api } = apiConfig()

const department = {
  namespaced: true,

  state: () => ({
    loading: false,
    departmentRegistrationSuccess: false,
    departmentRegistrationFailure: false
  }),

  getters: {
    _loading: state => state.loading,
    _departmentRegistrationSuccess: state =>
      state.departmentRegistrationSuccess,
    _departmentRegistrationFailure: state => state.departmentRegistrationFailure
  },

  mutations: {
    LOADING (state, value) {
      state.loading = value
    },
    DEPARTMENT_REGISTRATION_SUCCESS (state, value) {
      state.departmentRegistrationSuccess = value
    },
    DEPARTMENT_REGISTRATION_FAILURE (state, value) {
      state.departmentRegistrationFailure = value
    }
  },

  actions: {
    CreateDepartment ({ commit, rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        api
          .post('/InHouseDepartment/CreateInHouseDepartment', payload, {
            headers
          })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            commit('LOADING', false)
            commit('DEPARTMENT_REGISTRATION_SUCCESS', true)
            resolve(response)
          })
          .catch(error => {
            commit('LOADING', false)
            commit('DEPARTMENT_REGISTRATION_FAILURE', true)
            reject(error)
          })
      })
    },
    UpdateDepartment ({ commit, rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        api
          .post('/InHouseDepartment/UpdateInHouseDepartment', payload, {
            headers
          })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            commit('LOADING', false)
            commit('DEPARTMENT_REGISTRATION_SUCCESS', true)
            resolve(response)
          })
          .catch(error => {
            commit('LOADING', false)
            commit('DEPARTMENT_REGISTRATION_FAILURE', true)
            reject(error)
          })
      })
    },
    GetByIdDepartment ({ commit, rootState, dispatch }, XpressDepartmentID) {
      return new Promise((resolve, reject) => {
        commit('LOADING', true)
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        api
          .get(
            `/InHouseDepartment/GetAllDepartmentsByID?XpressDepartmentID=${XpressDepartmentID}`,
            { headers }
          )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllDepartments ({ rootState, commit, dispatch }) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        commit('LOADING', true)
        api
          .get('/InHouseDepartment/GetAllInHouseDepartments', { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    }
  }
}

export default department
